import { Component } from '@angular/core';

@Component({
  selector: 'app-redemption-report',
  imports: [],
  templateUrl: './redemption-report.component.html',
  styleUrl: './redemption-report.component.css'
})
export class RedemptionReportComponent {

}
